// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4v-1";
export var standaloneTable = "_4v-0";